import React from "react";
import {SimpleButton} from "./Actions/SimpleButton";

interface ActionSimpleButtonsInterface {
    item?: Object;
    buttons: any[];
}

export function ActionSimpleButtons({item, buttons}: ActionSimpleButtonsInterface) {
    return (
        <>
            {buttons.map((button, i) => (
                <SimpleButton key={i} button={button} item={item} />
            ))}
        </>
    );
}